# GraphQL fragment to enable/disable Office365 calendar sync

#import "../fragments/calendar-sync.graphql"

mutation setOffice365ConflictCalendarSyncIsEnabled($isEnabled: Boolean!) {
    setOffice365CalendarSyncIsEnabled(
        input: {calendarSync: {isEnabled: $isEnabled, isConflictCalendar: true}}
    ) {
        authUrl
        calendarSync {
            ...CalendarSync
        }
        newConnectionId
    }
}
